import type { ConnectionAccessFilter } from "../ConnectionAccessSettings";

export type ConnectionScopeCounts = Record<ConnectionAccessFilter, number>;

export const getConnectionScopeCounts = <TRow extends { isConnectionOwnedByCurrentUser: boolean }>(
    activeRows: TRow[],
): ConnectionScopeCounts => ({
    all: activeRows.length,
    owned_by_me: activeRows.filter((row) => row.isConnectionOwnedByCurrentUser).length,
});
